/**
 * § 384 — a composite's ARIA attributes belong on the element that carries its ROLE.
 *
 * Menu and Tab render a chrome wrapper around their `role="menu"` / `role="tablist"` element.
 * Spread onto the wrapper, a caller's `aria-labelledby` would name a generic `div` — which ARIA
 * does not allow — and leave the menu or tab list itself unnamed. So those two split their rest
 * props: every `aria-*` attribute reaches the role element, everything else the root, where the
 * ref points. (Where the root IS the role element — Dialog, SidePanel, DropdownButton's trigger —
 * nothing needs splitting.)
 */
export const splitAria = <P extends object>(props: P): { aria: Partial<P>; rest: Partial<P> } => {
  const aria: Record<string, unknown> = {};
  const rest: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(props)) {
    if (key.startsWith('aria-')) aria[key] = value;
    else rest[key] = value;
  }
  return { aria: aria as Partial<P>, rest: rest as Partial<P> };
};
